import { DynamicStandaloneLink } from '@/components/Link';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import Head from 'next/head';
import { ReactNode } from 'react';
import { Http404, Http404Props } from './404';
import { Http404DescriptionProps } from './404.Description';
import { Http404HeadlineProps } from './404.Headline';

const StandaloneHttp404Defaults: {
  description: StandaloneHttp404Props['description'];
  headline: StandaloneHttp404Props['headline'];
  title: StandaloneHttp404Props['title'];
} = {
  description: (
    <>
      <p>Vi kunde tyvärr inte hitta sidan du letade efter.</p>
      <p>
        <DynamicStandaloneLink href="/" content="Klicka här" /> för att komma tillbaka till startsidan eller välj något
        i menyn ovan.
      </p>
    </>
  ),
  headline: `OJDÅ, NU BLEV DET LITE TOKIGT (404)`,
  title: `Sidan saknas (404)`,
};

export interface StandaloneHttp404Props extends StandaloneComponentProps {
  description?: ReactNode;
  headline?: ReactNode;
  title?: string;
  options?: Http404Props & {
    $description?: Http404DescriptionProps;
    $headline?: Http404HeadlineProps;
  };
}

export const StandaloneHttp404: StandaloneComponent<StandaloneHttp404Props> = ({
  description,
  headline,
  title,
  options,
  ...props
}) => {
  const { $description: descriptionProps, $headline: headlineProps, ...baseProps } = options ?? {};

  return (
    <>
      <Head>
        <title>{title || StandaloneHttp404Defaults.title}</title>
      </Head>
      <Http404 {...baseProps} {...props}>
        <Http404.Headline {...headlineProps}>{headline || StandaloneHttp404Defaults.headline}</Http404.Headline>
        <Http404.Description {...descriptionProps}>
          {description || StandaloneHttp404Defaults.description}
        </Http404.Description>
      </Http404>
    </>
  );
};

export default StandaloneHttp404;
